import React, { useState, useEffect } from 'react';
import { getSecureMediaUrl, clearMediaCache } from '../../utils/secureMedia';
import './CreativeModal.css';

const ViewCreativeModal = ({ isOpen, creative, onClose }) => {
  const [mediaBlobUrls, setMediaBlobUrls] = useState({}); // 🔒 Безопасные blob URLs
  
  // 🔒 Загружаем медиафайлы через безопасный метод (Authorization заголовок)
  useEffect(() => {
    const loadMediaFiles = async () => {
      if (!creative?.media_external_ids || creative.media_external_ids.length === 0) return;
      
      const blobUrls = {};
      for (const fileId of creative.media_external_ids) {
        try {
          const blobUrl = await getSecureMediaUrl(fileId);
          blobUrls[fileId] = blobUrl;
        } catch (error) {
          console.error(`Ошибка загрузки файла ${fileId}:`, error);
        }
      }
      
      setMediaBlobUrls(blobUrls);
    };

    if (isOpen && creative) {
      loadMediaFiles();
    }
    
    // Очищаем blob URLs при размонтировании
    return () => {
      if (!isOpen) {
        clearMediaCache();
      }
    };
  }, [isOpen, creative]);

  if (!isOpen || !creative) return null;

  const getMediaUrl = (fileId) => {
    // Возвращаем blob URL из кеша (загруженный через Authorization заголовок)
    return mediaBlobUrls[fileId] || null;
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content modal-large" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Просмотр креатива</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        
        <div className="modal-body">
          <div className="creative-details">
            <div className="detail-row">
              <label>ERID:</label>
              <span className="detail-value">{creative.erid}</span>
            </div>
            
            <div className="detail-row">
              <label>Название:</label>
              <span className="detail-value">{creative.name}</span>
            </div>

            {creative.description && (
              <div className="detail-row">
                <label>Описание:</label>
                <span className="detail-value">{creative.description}</span>
              </div>
            )}

            {creative.brand && (
              <div className="detail-row">
                <label>Бренд:</label>
                <span className="detail-value">{creative.brand}</span>
              </div>
            )}

            {creative.category && (
              <div className="detail-row">
                <label>Категория:</label>
                <span className="detail-value">{creative.category}</span>
              </div>
            )}

            {creative.kktus && creative.kktus.length > 0 && (
              <div className="detail-row">
                <label>Код ККТУ:</label>
                <div className="detail-value">
                  {creative.kktus.map((kktu, index) => (
                    <span key={index} className="kktu-item">{kktu}</span>
                  ))}
                </div>
              </div>
            )}

            {creative.target_urls && creative.target_urls.length > 0 && (
              <div className="detail-row">
                <label>Целевые ссылки:</label>
                <div className="detail-value">
                  {creative.target_urls.map((url, index) => (
                    <a key={index} href={url} target="_blank" rel="noopener noreferrer" className="target-url">
                      {url}
                    </a>
                  ))}
                </div>
              </div>
            )}

            {creative.targeting && (
              <div className="detail-row">
                <label>Таргетинг:</label>
                <span className="detail-value">{creative.targeting}</span>
              </div>
            )}

            {creative.texts && creative.texts.length > 0 && (
              <div className="detail-row">
                <label>Текст креатива:</label>
                <div className="detail-value creative-text">
                  {creative.texts[0]}
                </div>
              </div>
            )}
            
            <div className="detail-row">
              <label>Договор:</label>
              <span className="detail-value contract-link">
                {creative.contract_external_id || 'Не указан'}
              </span>
            </div>

            {creative.media_external_ids && creative.media_external_ids.length > 0 && (
              <div className="detail-row">
                <label>Медиафайлы ({creative.media_external_ids.length}):</label>
                <div className="media-files-grid">
                  {creative.media_external_ids.map((fileId, index) => (
                    <div key={index} className="media-file-card">
                      <img
                        src={getMediaUrl(fileId)}
                        alt={`Медиафайл ${index + 1}`}
                        className="media-preview"
                      />
                      <span className="file-id-text">{fileId.substring(0, 8)}...</span>
                      {mediaBlobUrls[fileId] && (
                        <a href={mediaBlobUrls[fileId]} target="_blank" rel="noopener noreferrer" className="media-download-link">Открыть</a>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className="detail-row">
              <label>Статус:</label>
              <span className={`detail-value status-${creative.status}`}>
                {creative.status === 'active' ? 'Активный' : 
                 creative.status === 'draft' ? 'Черновик' : 
                 creative.status}
              </span>
            </div>

            {creative.created_at && (
              <div className="detail-row">
                <label>Создан:</label>
                <span className="detail-value">{new Date(creative.created_at).toLocaleString('ru-RU')}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewCreativeModal;
